import { toast } from "@/components/toast/toast-queue";
import apiClient from "@/lib/api/client";

export function useEnterAccount() {
  return async (projectId: number): Promise<void> => {
    const tab = window.open("about:blank", "_blank");

    try {
      await apiClient
        .url("/users/me")
        .patch({ currentProjectId: projectId })
        .res();

      if (tab) tab.location.href = "/requests?filter=all";
    } catch {
      tab?.close();
      toast.add(
        {
          title: "You don't have access to this account",
          type: "error",
        },
        { timeout: 5000 },
      );
    }
  };
}
